import React, { useEffect, useState, useContext } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  CardMedia,
  TextField,
  CircularProgress,
  createTheme,
  ThemeProvider,
  Avatar,
} from "@material-ui/core";
import {
  ApptContext,
  Facility,
  FacilityRegion,
  InitialApptObj,
  InitialSlotsObj,
} from "../../../../../../store";
import useStyles from "../../../../../../css/styles_PE";
import {
  GetFacilities,
  GetFacilityRegions,
} from "../../../../../../api/PE_API";
import { useNavigate } from "react-router-dom";
import { Autocomplete } from "@mui/lab";
import { InsertPPLogs } from "../../../../../../api";

// Update log
// FB  6192   02/06/2023  DK  Added for by location workflow
// FB  7143   09/28/2023  GA  Orady - Update the map link to the correct one
// FB  8722   11/06/2024  DK  PE workflows enhancements

export default function LocationComponent(props: any) {
  const { state, dispatch } = useContext(ApptContext);
  const [facilities, setFacilities] = useState<Facility[]>([]);
  const [facilitiesopen, setFacilitiesOpen] = useState(false);
  const facilitiesLoader = facilitiesopen && facilities.length === 0;
  const [regions, setRegions] = useState<FacilityRegion[]>([]);
  const [regionsopen, setRegionsOpen] = useState(false);
  const regionsLoader = regionsopen && regions.length === 0;
  const [selectedfacility, setSelectedfacility] = useState<Facility>(
    state.Facility
  );
  const [selectedregion, setSelectedRegion] = useState<FacilityRegion>(
    state.FacilityRegion
  );
  const navigate = useNavigate();
  const styles = useStyles();
  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
      action: {
        selected: "#8BD0DB",
        hover: "#5DBDCD",
      },
    },
  });
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }
  const handleRegionChange = (event: any, value: any) => {
    if (value != null) {
      setSelectedRegion(value as FacilityRegion);
      state.AppointmentType = state.AppointmentType;
      state.AppointmentFilter = state.AppointmentFilter;
      state.Provider = {
        ID: 0,
        Name: "",
        Facility_n: 0,
        Bio: "",
        JobTitle: ""
      };
      state.Facility = {
        ID: 0,
        Name: "",
        Address: "",
        Phone: "",
        Region: 0,
        GOOGLE_MAPS_LINK: "" //FB 7413
      };
      state.FacilityRegion = value as FacilityRegion;
      state.AppointmentDate = new Date();
      state.Duration = 0;
      state.SlotDetails = InitialSlotsObj;
      state.Appointment_N = 0;

      //ModifyAppointmentObject(state, dispatch);
      InsertPPLogs(
        "Selected the region " + value.name,
        window.location.href,
        userName,
        ""
      );
    } else {
      setSelectedRegion(InitialApptObj.FacilityRegion);
    }
    setSelectedfacility(InitialApptObj.Facility);
  };
  const handleChange = (event: any, value: any) => {
    if (value != null) {
      setSelectedfacility(value as Facility);
      modifyState(value);

      InsertPPLogs(
        "Selected the location " + value.name,
        window.location.href,
        userName,
        ""
      );
      //ModifyAppointmentObject(state, dispatch);
    } else {
      setSelectedfacility(InitialApptObj.Facility);
    }
  };
  const handleGoback = () => {
    InsertPPLogs(
      "Clicked on Go Back - by office location",
      window.location.href,
      userName,
      ""
    );
    props.setApptFilter("");
  };
  const handleProceed = () => {
    InsertPPLogs(
      "Clicked on Show Schedule - by office location",
      window.location.href,
      userName,
      ""
    );
    navigate("/user/bookappointment/facility/slots");
  };
  const scrollTo = (ref: any) => {
    if (ref) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  //FB 8722
  const [isSingleRegion, setIsSingleRegion] = useState(0);
  const [isSingleLocation, setIsSingleLocation] = useState(0);

  useEffect(() => {
    GetFacilityRegions().then((data: any) => {
      setRegions(data);
      // FB 8722
      if (data.length == 1) {
        setIsSingleRegion(1);
        let value = data[0];
        setSelectedRegion(value as FacilityRegion);
        state.FacilityRegion = value as FacilityRegion;
      }
    });

    GetFacilities(0).then((data) => {
      setFacilities(data);
    });
  }, []);

  //FB 8722 Start
  useEffect(() => {
    if (facilities.filter((facility) => facility.Region === selectedregion.ID).length == 1) {
      setIsSingleLocation(1);
      let value = facilities[0];
      setSelectedfacility(facilities[0] as Facility);
      modifyState(value);
    }
  }, [facilities]);

  function modifyState(value: Facility) {
    state.AppointmentType = state.AppointmentType;
    state.AppointmentFilter = state.AppointmentFilter;
    state.Provider = {
      ID: 0,
      Name: "",
      Facility_n: 0,
      Bio: "",
      JobTitle: ""
    };
    state.Facility = value;
    state.FacilityRegion = state.FacilityRegion;
    state.AppointmentDate = new Date();
    state.Duration = 0;
    state.SlotDetails = InitialSlotsObj;
    state.Appointment_N = 0;
  }
  //FB 8722 End

  return (
    <div ref={scrollTo}>
      {/* FB 8722 */}
      <Grid container spacing={2} style={{ display: isSingleRegion == 0 ? "flex" : "none" }}>
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Typography variant="h6">Please choose the region</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <ThemeProvider theme={theme}>
            <Autocomplete
              id="regionlist"
              className={styles.dropdown_nomargin}
              fullWidth
              onChange={handleRegionChange}
              value={selectedregion}
              options={regions.sort((a, b) => -b.State.localeCompare(a.State))}
              getOptionLabel={(option) => option.Name}
              groupBy={(options) => options.State}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              classes={{
                popupIndicator: styles.autocompleteIcon,
              }}
              open={regionsopen}
              loading={regionsLoader}
              onOpen={() => {
                setRegionsOpen(true);
              }}
              onClose={() => {
                setRegionsOpen(false);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Region"
                  id="region"
                  variant="standard"
                  InputProps={{
                    style: { borderColor: "red" },
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {regionsLoader ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </ThemeProvider>
        </Grid>
      </Grid>
      {/* FB 8722 Start */}
      <Grid container spacing={2} style={{ display: isSingleRegion == 1 ? "flex" : "none" }}>
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Typography variant="h6">Selected region</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <label>{selectedregion.Name}</label>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        style={{
          display: selectedregion.ID > 0 && isSingleLocation == 0 ? "flex" : "none",
        }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Typography variant="h6">Please choose the location</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <ThemeProvider theme={theme}>
            <Autocomplete
              id="facilitylist"
              className={styles.dropdown_nomargin}
              fullWidth
              onChange={handleChange}
              value={selectedfacility}
              getOptionLabel={(option) => option.Name}
              options={facilities.filter(
                (facility) => facility.Region === selectedregion.ID
              )}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              classes={{
                popupIndicator: styles.autocompleteIcon,
              }}
              open={facilitiesopen}
              loading={facilitiesLoader}
              onOpen={() => {
                setFacilitiesOpen(true);
              }}
              onClose={() => {
                setFacilitiesOpen(false);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Location"
                  id="location"
                  variant="standard"
                  InputProps={{
                    style: { borderColor: "red" },
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {facilitiesLoader ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </ThemeProvider>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        style={{
          display: selectedregion.ID > 0 && isSingleLocation == 1 ? "flex" : "none",
        }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Typography variant="h6">Selected location</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <label>{selectedfacility.Name}</label>
        </Grid>
      </Grid>
      {/* FB 8722 End*/}
      <Grid
        container
        spacing={2}
        style={{
          display: selectedfacility.ID > 0 ? "flex" : "none",
        }}
      >
        <Grid item xs={12} sm={6} md={5}></Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          lg={5}
          style={{
            display: "flex",
            justifyContent: window.innerWidth <= 768 ? "center" : "",
          }}
        >
          <Card className={styles.location_Card}>
            <CardMedia style={{ display: "flex", justifyContent: "center" }}>
              <Avatar
                style={{ margin: 5 }}
                className={styles.card_Avatar}
                src={`/Images/Locations/${selectedfacility.ID}.jpg`}
              />
            </CardMedia>
            <CardContent>
              <Typography id="selectedFacilityName" variant="h6">
                <b>{selectedfacility.Name}</b>
              </Typography>
              <Typography id="selectedfacility">
                {selectedfacility.Address.includes("null")
                  ? ""
                  : selectedfacility.Address}
              </Typography>
              <Typography>
                {selectedfacility.Phone !== ""
                  ? "(" +
                  selectedfacility.Phone?.slice(0, 3) +
                  ") " +
                  selectedfacility.Phone?.slice(3, 6) +
                  "-" +
                  selectedfacility.Phone?.slice(6, 10)
                  : ""}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid container spacing={3} className={styles.flexend_Grid}>
        <Grid
          item
          xs={6}
          sm={4}
          md={3}
          lg={2}
          style={{
            display: selectedfacility.ID > 0 ? "block" : "none",
          }}
        >
          <Button
            variant="contained"
            id="showScheduleLocation"
            className={styles.navigationButton}
            onClick={handleProceed}
          >
            Show Schedule
          </Button>
        </Grid>
        <Grid item xs={6} sm={4} md={2} lg={2} className={styles.flexend_Grid}>
          <Button
            onClick={handleGoback}
            variant="contained"
            className={styles.navigationButton}
          >
            Go Back
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
